import React, {Component} from 'react';
import {Button, FormGroup} from 'reactstrap';
import autobind from 'autobind-decorator';
import {connect} from 'react-redux';
import * as contacts from 'customers/actions/contacts';
import {DetailContainer} from 'customers/DetailContainer';
import {Formik, Form, Field} from 'formik';
import {CustomField} from 'apa/components/CustomField';
import * as yup from 'yup';
import Loading from 'apa/components/Loading';

const ContactScheme = yup.object().shape(
    {
        acronym: yup.string().length(2),
        type: yup.string(),
        title: yup.string(),
        name: yup.string().required(),
        email: yup.string().email(),
        phone: yup.string(),
        mobile: yup.string(),
        note: yup.string(),

    }
);

@connect(
    state => (
        {
            auth: state.apa
        }
    ),
    dispatch => {
        return (
            {
                add: (contact, history) => dispatch(contacts.add(contact, history)),
                update: (contact, history) => dispatch(contacts.update(contact, history))
            }
        )
    }
)
export default class ContactDetails extends Component {
    constructor(props) {
        super(props);
        const contact = props.match.params.contact_id;
        if (contact) {
            this.state = {
                isNew: false,
                isLoading: true,
            }
        } else {
            const customer_id = props.match.params.customer_id;
            this.state = {
                isNew: true,
                isLoading: false,
                customer: customer_id,
                contact: {
                    acronym: '',
                    type: '',
                    title: '',
                    name: '',
                    email: '',
                    phone: '',
                    mobile: '',
                    note: ''
                }
            }
        }
    }

    componentDidMount() {
        const headers = {'Content-Type': 'application/json'};
        headers['Authorization'] = `Token ${this.props.auth.token}`;

        if (!this.state.isNew) {
            const id = this.props.match.params.contact_id;
            fetch(
                `https://apabackend.quixtest.de/api/contacts/${id}/`,
                {headers}
            )
                .then(res => res.json())
                .then(
                    contact => {
                        this.setState(
                        {
                            
                            contact: contact
                        }
                    )
                    fetch(
                        `https://apabackend.quixtest.de/api/customers/${contact.customer}/?year=2019`,
                        {headers}
                    )
                        .then(res => res.json())
                        .then(
                            customer => this.setState(
                                {
                                    isLoading: false,
                                    customer: customer
                                }
                            )
                        )
        
                    }
                )
        }
        if(this.state.customer) {
            fetch(
                `https://apabackend.quixtest.de/api/customers/${this.state.customer}/?year=2019`,
                {headers}
            )
                .then(res => res.json())
                .then(
                    customer => this.setState(
                        {
                            customer: customer
                        }
                    )
                )

        }

    }

    @autobind
    onSubmit(values) {
        if (this.state.isNew)
            this.props.add(
                {
                    ...values,
                    customer: this.state.customer.id
                },
                this.props.history
            );
        else
            this.props.update(
                values,
                this.props.history
            );
        this.props.history.push(
            `/customer/${this.props.match.params.customer_id || this.state.customer.id}/contacts`
        )
    }

    render() {
        
        if (this.state.isLoading)
            return <Loading/>;
        const customer_id = this.props.match.params.customer_id || this.state.customer.id;
        return (
            <DetailContainer id={customer_id}>
                <h1>{this.state.customer.name}</h1>
                <Formik
                    initialValues={this.state.contact}
                    validationSchema={ContactScheme}
                    onSubmit={this.onSubmit}
                >
                    {({isSubmitting}) =>
                        (
                            <Form className='form'>
                                <FormGroup>
                                    <Field component={CustomField} type='text' name='acronym' label='Kürzel'/>
                                </FormGroup>
                                <FormGroup>
                                    <Field component={CustomField} type='text' name='type' label='Funktion'/>
                                </FormGroup>
                                <FormGroup>
                                    <Field component={CustomField} type='text' name='title' label='Anrede'/>
                                </FormGroup>
                                <FormGroup>
                                    <Field component={CustomField} type='text' name='name' label='Name'/>
                                </FormGroup>
                                <FormGroup>
                                    <Field component={CustomField} type='email' name='email' label='E-Mail'/>
                                </FormGroup>
                                <FormGroup>
                                    <Field component={CustomField} type='text' name='phone' label='Festnetz'/>
                                </FormGroup>
                                <FormGroup>
                                    <Field component={CustomField} type='text' name='mobile' label='Mobil'/>
                                </FormGroup>
                                <FormGroup>
                                    <Field component={CustomField} type='textarea' name='note' label='Notiz'/>
                                </FormGroup>
                                <FormGroup>
                                    <Button color='primary' type='submit' disabled={isSubmitting}>
                                        Speichern
                                    </Button>
                                </FormGroup>
                            </Form>
                        )}
                </Formik>
            </DetailContainer>
        )
    }
}
